import { render, staticRenderFns } from "./Manifesto.vue?vue&type=template&id=2177fb6a&scoped=true"
import script from "./Manifesto.vue?vue&type=script&lang=js"
export * from "./Manifesto.vue?vue&type=script&lang=js"
import style0 from "./Manifesto.vue?vue&type=style&index=0&id=2177fb6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2177fb6a",
  null
  
)

export default component.exports